import ActionButton from 'components/buttons/index';

import { IAudienceCustomDialogFooter } from './types';
import { Grid } from '@mui/material';
import { styles } from './styles';

export const AudienceCustomDialogFooter = ({
  doneDisabled,
  isLoading,
  onCancel,
  onDone,
}: IAudienceCustomDialogFooter) => {
  return (
    <Grid sx={{ marginTop: '40px' }}>
      <Grid container justifyContent="flex-end" sx={styles.buttonContainer}>
        <ActionButton
          type="button"
          variant="secondary"
          onClick={onCancel}
          label="Cancel"
          style={styles.cancelButton}
          disabled={isLoading}
        />
        <ActionButton
          type="submit"
          loading={isLoading}
          variant="primary"
          label="Done"
          disabled={doneDisabled}
          onClick={() => {
            if (doneDisabled) return;
            onDone();
          }}
        />
      </Grid>
      <Grid />
    </Grid>
  );
};
